define('TescoMobile_Checkout/js/view/cca-step',['Magento_Ui/js/form/form', 'Magento_Checkout/js/model/quote', 'jquery', 'Magento_Checkout/js/model/step-navigator', 'TescoMobile_Checkout/js/action/payment-accept', 'TescoMobile_Checkout/js/action/credit-check', 'Magento_Checkout/js/model/full-screen-loader', 'TescoMobile_Checkout/js/model/payment-information', 'mage/translate', 'uiRegistry', 'underscore', 'Magento_Checkout/js/model/error-processor', '../model/cancelled-order-processor', '../model/create-callback-url'], function (Component, quote, $, stepNavigator, paymentAccept, creditCheck, fullScreenLoader, paymentInformation, $t, registry, _, errorProcessor, cancelledOrderProcessor, createCallbackUrl) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/cca-step',
      visible: false,
      ccaIframeUrl: paymentInformation.ccaIframeUrl
    },
    isLoading: false,
    formSelector: '#cca-payment-accept-form',
    initialize: function () {
      this._super();
      stepNavigator.registerStep('cca-step', 'cca-step', $t('Credit agreement'), this.visible, _.bind(this.navigate, this), this.sortOrder);
      window.addEventListener('message', function (event) {
        var _event$data, _event$data2;
        if (event.origin !== window.BASE_URL.replace(/\/$/, '')) {
          return;
        }
        const messageContainer = registry.get('checkout.errors').messageContainer;
        if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.status) === 'cca-capture-success') {
          if (quote.getTotals()().base_grand_total > 0) {
            creditCheck(messageContainer).done(response => {
              const payment_iframe_url = response.payment_iframe_url;
              if (payment_iframe_url) {
                paymentInformation.paymentIframeUrl(createCallbackUrl.payment(payment_iframe_url));
              }
              stepNavigator.next();
            });
          } else {
            stepNavigator.next();
          }
        } else if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.status) === 'cca-capture-error') {
          messageContainer.addErrorMessage(event.data);
        }
      });
    },
    initObservable: function () {
      this._super().observe(['visible', 'paymentIframeUrl', 'isLoading', 'successLoaded', 'aggrementText', 'ccaIframeUrl']);
      return this;
    },
    navigate: function (step) {
      step && step.isVisible(true);
      if (!this.ccaIframeUrl()) {
        const messageContainer = registry.get('checkout.errors').messageContainer;
        creditCheck(messageContainer, {}).done(function (response) {
          const payment_iframe_url = response.payment_iframe_url,
            response_code = response.response_code;
          if (response_code === 'CO_281') {
            paymentInformation.ccaIframeUrl(createCallbackUrl.cca(payment_iframe_url));
          } else if (['CO_141', 'CO_145'].includes(response_code)) {
            cancelledOrderProcessor.setMessage(response);
          } else if (response_code === 'CO_140') {
            paymentInformation.response(response);
            stepNavigator.setHash('payment');
          } else {
            errorProcessor.process(response, messageContainer);
          }
        }).fail(function (response) {
          errorProcessor.process(response, messageContainer);
        });
      }
    }
  });
});

